import { style } from "typestyle";

export const errorCard = style({
  display: "flex",
  alignContent: "center",
  flexDirection: "column",
  alignItems: "center",
  width: "330px",
  background: "white",
  padding: "16px 24px",
  borderRadius: "1rem",
  margin: "2rem auto",
});
